import { render, staticRenderFns } from "./Hojagrafica.vue?vue&type=template&id=36624666"
import script from "./Hojagrafica.vue?vue&type=script&lang=js"
export * from "./Hojagrafica.vue?vue&type=script&lang=js"
import style0 from "./Hojagrafica.vue?vue&type=style&index=0&id=36624666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports